import { useState } from 'react';
import styled, { useTheme } from 'styled-components'; // Corrected import
import urls from '../../utils/urls';
import { isValidEmail } from '../../utils/stringUtils';

const EmailContainer = styled.div`
  width: 100%;
  max-width: 700px; /* Centered form */
  margin: 0 auto; /* Center form container */
  padding-bottom: 2rem; /* Adjusted padding */
  /* padding-top is removed as SectionTitle provides top margin */
`;

const Input = styled.input`
  width: calc(50% - 2rem); /* Adjust width considering margin */
  height: auto; /* Auto height based on padding */
  margin: 1rem;
  padding: 0.75rem 1rem; /* Adjusted padding */
  border: 1px solid ${(props) => props.theme.colors.borders}; /* Updated */
  border-radius: ${(props) => props.theme.borderRadius}; /* Updated */
  background-color: ${(props) => props.theme.colors.surface}; /* Updated */
  color: ${(props) => props.theme.colors.text}; /* Updated */
  font-family: ${(props) => props.theme.fontFamilies.secondary}; /* Updated */
  font-size: ${(props) => props.theme.fontSizes.body}; /* Updated */
  transition: border-color 0.3s ease, box-shadow 0.3s ease;

  @media (max-width: 600px) {
    width: calc(100% - 2rem); /* Full width on smaller screens */
    margin: 0.5rem 1rem; /* Adjust margin */
  }

  &:focus {
    outline: none;
    border-color: ${(props) => props.theme.colors.primary}; /* Updated */
    box-shadow: 0 0 0 2px ${(props) => props.theme.colors.primary}40; /* Added focus glow */
  }
`;

const Textarea = styled.textarea`
  width: calc(100% - 2rem); /* Full width within Row, accounting for margin */
  min-height: 8rem; /* Adjusted height */
  margin: 1rem;
  padding: 0.75rem 1rem; /* Adjusted padding */
  border: 1px solid ${(props) => props.theme.colors.borders}; /* Updated */
  border-radius: ${(props) => props.theme.borderRadius}; /* Updated */
  background-color: ${(props) => props.theme.colors.surface}; /* Updated */
  color: ${(props) => props.theme.colors.text}; /* Updated */
  font-family: ${(props) => props.theme.fontFamilies.secondary}; /* Updated */
  font-size: ${(props) => props.theme.fontSizes.body}; /* Updated */
  resize: vertical; 
  transition: border-color 0.3s ease, box-shadow 0.3s ease;

  @media (max-width: 600px) {
    width: calc(100% - 2rem); /* Full width on smaller screens */
    margin: 0.5rem 1rem; /* Adjust margin */
  }

  &:focus {
    outline: none;
    border-color: ${(props) => props.theme.colors.primary}; /* Updated */
    box-shadow: 0 0 0 2px ${(props) => props.theme.colors.primary}40; /* Added focus glow */
  }
`;
const Button = styled.button`
  /* width: 10rem; Removed fixed width, let padding define it */
  /* height: 3rem; Removed fixed height */
  margin: 1rem;
  padding: 0.75rem 1.5rem; /* Adjusted padding */
  background-color: ${(props) => props.theme.colors.primary}; /* Updated */
  color: ${(props) => props.theme.colors.surface}; /* Updated (assuming primary is dark enough for light text) */
  border: none;
  font-weight: 600; /* Adjusted font-weight */
  font-size: ${(props) => props.theme.fontSizes.body}; /* Updated */
  font-family: ${(props) => props.theme.fontFamilies.primary}; /* Updated */
  border-radius: ${(props) => props.theme.borderRadius}; /* Updated */
  align-self: center;
  cursor: pointer;
  transition: background-color 0.3s ease; 

  &:hover {
    background-color: ${(props) => props.theme.colors.accentHover}; /* Updated */
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px ${(props) => props.theme.colors.primary}40; /* Consistent focus like inputs */
  }
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: center;
  align-items: center;
  align-content: center;
  align-self: center;
  display: flex;
  @media (max-width: 600px) {
    flex-direction: column; /* Stack inputs on smaller screens */
    align-items: stretch; /* Make inputs take full width */
  }
`;

function Email() {
  const theme = useTheme(); // Correctly initialize theme
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    comment: '',
  });

  const handleSubmit = async () => {
    if (!formData.name || !formData.email || !formData.comment) {
      alert('Please fill out all fields');
      return;
    }
    if (!isValidEmail(formData.email)) {
      alert('Invalid email');
      return;
    }

    const response = await fetch(urls.sendEmail, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      alert('Email sent successfully');
    } else {
      alert('Failed to send email');
    }
  };

  return (
    <EmailContainer>
      <Row>
        <Input
          type="text" // Add input type as "text"
          placeholder="Name*"
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          value={formData.name}
          minLength={3} 
          style={{ borderColor: formData.name.length < 3 ? theme.colors.error : theme.colors.borders }} 
        />
        <Input
          placeholder="Email*"
          type="email"
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
          value={formData.email}
          minLength={5} 
          style={{
            borderColor: !isValidEmail(formData.email) ? theme.colors.error : theme.colors.borders, 
          }}
        />
      </Row>
      <Row>
        <Textarea
          placeholder="Comment*"
          onChange={(e) =>
            setFormData({ ...formData, comment: e.target.value })
          }
          value={formData.comment}
          minLength={10} 
          style={{ borderColor: formData.comment.length < 10 ? theme.colors.error : theme.colors.borders }} 
        />
      </Row>
      <Row>
        <Button onClick={handleSubmit}>SUBMIT</Button>
      </Row>
    </EmailContainer>
  );
}
export default Email;
